import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom'
import './header.css'
import Lenguage from '../Lenguage/Lenguage';
import { TablesFetchAPI } from '../../../api/Tables';


//Components

import RestaurantModal from '../../Restaurant/RestaurantModal'

//Utils 
import { RenderIf } from '../utils/RenderIf';
import ModalLanguage from './ModalLanguage';
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';
export const Header = ({ type, shoppingcart, shoppingCartCombos }) => {
   const navigate = useNavigate();

   //const { business_code, branchoffice_code, machine_code_table } = useParams();
   const [businessCode, setbusinessCode] = useState(() => {
      if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
         return JSON.parse(localStorage.getItem("business")).code
      }
   });

   const [branchoffice_code, setbranchoffice_code] = useState(() => {
      if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
         return JSON.parse(localStorage.getItem("branchoffice")).code
      }
   });
   const [machine_code_table, setmachine_code_table] = useState(() => {
      if (localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
         return JSON.parse(localStorage.getItem("machine")).code
      }
   });

   const [modalShow, setModalShow] = React.useState(false);
   const [shop, setShop] = useState(() => {
      if (localStorage.getItem("shop") != "" && localStorage.getItem("shop") != undefined) { return true } else { return false }
   });
   let logo = localStorage.getItem('logo')
   let brachoffice_name = ''
   let codeTable = ''

   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);
   const menuType = queryParams.get('type');


   if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      brachoffice_name = branchoffice.name
      //console.log(branchoffice);
   }

   let countProduct = 0
   if (shoppingcart != undefined) {
      shoppingcart.forEach((product) => {
         countProduct = (countProduct + parseInt(product.amount))
      });
   }

   if (shoppingCartCombos != undefined) {
      shoppingCartCombos.forEach((product) => {
         countProduct = (countProduct + parseInt(product.amount))
      });
   }




   //Bussines Information 
   let business = "";
   if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {
   } else {
      business = JSON.parse(localStorage.getItem("business"));
   }

   /*useEffect(() => {
      if (localStorage.getItem('codeRoom') != undefined && localStorage.getItem('codeRoom') != '' && localStorage.getItem('codeRoom') != null) {
         getTableById()
      }
   }, [])*/



   const [theme, setTheme] = useState('light');

   // Leer el tema desde localStorage al iniciar
   useEffect(() => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      setTheme(savedTheme);
      document.documentElement.setAttribute('data-theme', savedTheme);
   }, []);

   // Cambiar tema y guardar en localStorage
   const toggleTheme = () => {
      const newTheme = theme === 'light' ? 'dark' : 'light';
      setTheme(newTheme);
      document.documentElement.setAttribute('data-theme', newTheme);
      localStorage.setItem('theme', newTheme);
   };





   return (
      <>
         <header className=' text-center fw-bold py-3 mx-lg-5'>
            <div className='flex-row d-lg-flex justify-content-lg-between  align-items-lg-center'>

               <div className='d-flex justify-content-center align-items-center mb-lg-0 mb-3'>
                  <div className='me-2'>
                     <img src={buildCloudinaryImageUrl({ url: logo, width: 300, quality: "auto", type: "image" }) || undefined}
                        alt="Logo Bussiness" className='logo-img' />
                  </div>

                  {/* <h1 className='flw-bold text-header-ecommerce '>
                     {business.name}
                  </h1> */}
               </div>






               {type === 'restaurant'
                  ? <><ModalLanguage></ModalLanguage></>
                  : <>
                     <div className='d-flex justify-content-between gap-1'>
                        {/** Home button */}
                        <RenderIf isTrue={menuType !== "points"}>
                           <NavLink
                              to={`/home/?type=points`}>

                              <button className="icon-button tooltip-container">
                                 <i className="uil uil-coins icon-header-ecommerce"></i>
                                 <span className="tooltip-text">Puntos </span>
                              </button>
                           </NavLink>
                        </RenderIf> 

                        <RenderIf isTrue={menuType === "points"}>
                           <NavLink
                              to={`/home`}>
                              <button className="icon-button tooltip-container">
                                 <i className="uil uil-money-bill icon-header-ecommerce"></i>
                                 <span className="tooltip-text">Puntos </span>
                              </button>
                           </NavLink>
                        </RenderIf>











                        <NavLink to={`/branch/select/${true}`}>
                         <RestaurantModal brachoffice_name={brachoffice_name} /></NavLink>
                        {/** Profile button */}
                        <ModalLanguage></ModalLanguage>


                        {/* Theme dark-light */}
                        <div>

                           {/* <button onClick={toggleTheme} className='icon-button  '>
                              {theme === 'dark' ? <>   <i class="uil uil-moon icon-header-ecommerce"></i></> : <>   <i class="uil uil-sun icon-header-ecommerce"></i></>}
                           </button> */}

                           <button className="icon-button tooltip-container" onClick={toggleTheme}>
                              {theme === 'dark'
                                 ? <>   <i class="uil uil-moon icon-header-ecommerce"></i></>
                                 : <>   <i class="uil uil-sun icon-header-ecommerce"></i></>}

                              <span className="tooltip-text">
                                 {theme === 'dark'
                                    ? <>  Modo: Dark </>
                                    : <>   Modo: Light     </>
                                 }

                              </span>
                           </button>
                        </div>

                        <NavLink
                           to={`/profile`}>
                           <button className="icon-button tooltip-container">
                              <i className="uil uil-user icon-header-ecommerce"></i>
                              <span className="tooltip-text">Perfil de Usuario</span>
                           </button>
                        </NavLink>




                        {/** Shopping Cart button */}



                        <NavLink
                           to={`/cart`}
                           className={'position-relative'}
                        >
                           {/* <button className='btn btn-header-ecommerce  btn-sm rounded-4'>
                              <i className="uil uil-shopping-cart icon-header-ecommerce"></i>
                           </button> */}

                           <button className="icon-button tooltip-container">
                              <i className="uil uil-shopping-cart icon-header-ecommerce"></i>
                              <span className="tooltip-text">Carrito</span>
                           </button>
                           {
                              countProduct > 0
                                 ? <>
                                    <span class="position-absolute  top-0 start-50 translate-middle  badge rounded-pill text-bg-primary px-2 py-1">
                                       {countProduct}
                                    </span>
                                 </>
                                 : <>
                                 </>
                           }
                        </NavLink>




                        {/** Orders button */}
                        {/* <NavLink
                           to={`/orders`}>

                           <button className="icon-button tooltip-container">
                              <i className="uil uil-receipt icon-header-ecommerce"></i>
                              <span className="tooltip-text">Ordenes</span>
                           </button>
                        </NavLink>  */}

                        {/** Notification button */}
                        {/* <RenderIf isTrue={branchoffice_code !== undefined && machine_code_table !== undefined}>
                           <NavLink
                              to={`/notifications`}>
                              <button className="icon-button tooltip-container">
                                 <i className="uil uil-bell icon-header-ecommerce"></i>
                                 <span className="tooltip-text">Notificaciones</span>
                              </button>
                           </NavLink>
                        </RenderIf> */}

                     </div>


                  </>}
            </div>
         </header>

         {/* <div className='d-flex justify-content-center   px-1 shadow-sm'>
            <small className='fw-bold  text-store-header text-dark-emphasis' >  <i className="uil uil-store" ></i>: {brachoffice_name} </small>
         </div> */}
         {/* 
         <Lenguage
            show={modalShow}
            onHide={() => setModalShow(false)}
         /> */}
      </>


   )
}
